<script>
import Fade from 'linna/components/Fade'
import isMounted from 'linna/mixins/isMounted'

import Typewriter from '../snippets/Typewriter'

import GubbmannsHypothesis from '@/content/GubbmannsHypothesis.md'
import HistoryOfMan from '@/content/HistoryOfMan.md'

export default {
  name: 'StoryIntro',

  components: {
    Fade,
    Typewriter
  },

  mixins: [
    isMounted
  ],

  data () {
    return {
      currentSection: 0,
      sections: [
        GubbmannsHypothesis,
        HistoryOfMan
      ]
    }
  },

  computed: {

    message () {
      return this.sections[this.currentSection]
    }

  },

  methods: {

    advance () {
      this.currentSection++
    },

    onTypewriterComplete () {
      if (this.currentSection < this.sections.length - 1) {
        setTimeout(this.advance, 5000)
      } else {
        this.$emit('complete')
      }
    }

  }

}
</script>

<template>
  <div class="c-story-intro">
    <fade :appear="true">
      <typewriter
        v-if="isMounted"
        :key="currentSection"
        :message="message"
        class="c-story-intro-content"
        @complete="onTypewriterComplete(currentSection)"
      />
    </fade>
  </div>
</template>
